module.exports = __webpack_public_path__ + "img/DSC_1100.3bdd9b43.jpg";